import React, { useState, useEffect, useCallback } from 'react';
import styles from './Lightbox.module.css';

const Lightbox = ({ images, initialIndex = 0, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    const handleNext = useCallback(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, [images.length]);

    const handlePrev = useCallback(() => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    }, [images.length]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowRight') handleNext();
            if (e.key === 'ArrowLeft') handlePrev();
        };
        window.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'auto';
        };
    }, [onClose, handleNext, handlePrev]);

    if (!images || images.length === 0) return null;

    const currentSrc = images[currentIndex];

    return (
        <div className={styles.lightboxOverlay} onClick={onClose}>
            <div className={styles.lightboxContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose} aria-label="Close Lightbox">
                    &times;
                </button>

                {images.length > 1 && (
                    <button className={`${styles.navButton} ${styles.prevButton}`} onClick={handlePrev} aria-label="Previous image">
                        &#10094;
                    </button>
                )}

                <img src={currentSrc} alt={`Enlarged gallery image ${currentIndex + 1}`} className={styles.lightboxImage} />

                {images.length > 1 && (
                    <button className={`${styles.navButton} ${styles.nextButton}`} onClick={handleNext} aria-label="Next image">
                        &#10095;
                    </button>
                )}
            </div>
        </div>
    );
};

export default Lightbox;
